import SOSTab from "../../../../patient/details/sos/SOSTab";

export default function SOSDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <SOSTab inWorkQ={inWorkQ} />
    </div>
}
